export default __webpack_public_path__ + "media/images/images_v2/btn-add-c6a9d1eb2cfb42af28ccfd72ee6ad276.png";